import React from 'react'
import { Link } from 'react-router-dom'
import useCommunityIdOrSlug from '../../../hooks/useCommunityIdOrSlug'
import Routes from '../../../startup/routes'
import UserNav from './UserNav'
import { IconGlyph } from '../../../icons/IconGlyph'

const PublicFooter: React.FC = () => {
  const communityIdOrName = useCommunityIdOrSlug()

  return (
    <div className="public-footer">
      <nav className="public-nav">
        <ul>
          <li>
            <Link to={Routes.events(communityIdOrName)}>
              <IconGlyph name="calendar" color="red" />
              <span>Events</span>
            </Link>
          </li>
          <li>
            <Link to={Routes.places(communityIdOrName)}>
              <IconGlyph name="location" color="green" />
              <span>Places</span>
            </Link>
          </li>
          <li>
            <Link to={Routes.stories(communityIdOrName)}>
              <IconGlyph name="megaphone" color="blue" />
              <span>Stories</span>
            </Link>
          </li>
        </ul>
        <UserNav />
      </nav>
    </div>
  )
}

export default PublicFooter
